module.exports = __webpack_public_path__ + "static/img/Image_about-003.cdb692a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Image_about-003.png
// module id = puBm
// module chunks = 1